import React from 'react';
import { EditOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import styles from './EmailChangeMessage.module.scss';

interface EmailChangeMessageProps {
    recipientEmail: string;
    onEditEmail: () => void;
}

const EmailChangeMessage: React.FC<EmailChangeMessageProps> = ({ recipientEmail, onEditEmail }) => {
    const { t } = useTranslation();
    return (
        <div className={styles.messageBox} data-testid="recipientPage_userEmail_phoneVer">
            <div className={styles.message}>
                {t('recipientPage.OTPSteps.filesSentTo')}
                <span className={styles.email} data-testid="recipientPage_userEmailDisplay">
                    {recipientEmail}
                </span>
                <span className={styles.iconWrapper} onClick={onEditEmail}>
                    <EditOutlined />
                </span>
            </div>
            <div>{t('recipientPage.OTPSteps.changeEmail')}</div>
        </div>
    );
};

export default EmailChangeMessage;
